export default __webpack_public_path__ + "static/media/mist.8e607e76.gif";